import React from "react";
import ReactDOM from "react-dom/client";
import './index.css';
import App from './App';
import { Provider } from "react-redux";
import { store } from './store';

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    {/* --- 2. BỌC COMPONENT APP BẰNG PROVIDER --- */}
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
);
